import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import FormButtonOptionsInput from './FormInputs/FormButtonOptionsInput';

FormButtonOptions.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  isMultiSelect: PropTypes.bool,
  trailingOption: PropTypes.node,
};

export default function FormButtonOptions({ fieldName, fieldAttributes, isMultiSelect = false, trailingOption = null }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={() => (
        <FormButtonOptionsInput
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          isMultiSelect={isMultiSelect}
          trailingOption={trailingOption}
        />
      )}
    />
  );
}
